import PropTypes from 'prop-types';
import Image from 'next/image';

// Styles
import styles from './ServiceCard.module.css';

// Components
import RichTextContent from '../RichTextContent/RichTextContent';

function ServiceCard({
  media, title, content, tag,
}) {
  return (
    <div className={styles.container}>
      {media?.url ? (
        <div className={styles.imageContainer}>
          <div className={styles.image}>
            <Image
              src={media.url}
              alt={media?.description}
              fill
              sizes="33vw"
            />
          </div>
          {tag ? <span className={styles.tag}>{tag}</span> : null}
        </div>
      ) : null}
      <div className={styles.title}>
        {title}
      </div>
      <div
        className={styles.content}
      >
        <RichTextContent content={content} />
      </div>
    </div>
  );
}

ServiceCard.propTypes = {
  media: PropTypes.shape({
    url: PropTypes.string,
    description: PropTypes.string,
  }),
  title: PropTypes.string,
  content: PropTypes.string,
  tag: PropTypes.string,
};

ServiceCard.defaultProps = {
  media: {
    url: '',
    description: '',
  },
  title: '',
  content: '',
  tag: '',
};

export default ServiceCard;
